export default __webpack_public_path__ + "media/images/customers/mayflower-kiel/logo-0173613af64d84c57f086018456a929f.png";